/**
 * Just the name, for a caller about to write it back.
 *
 * `name` belongs to both of Service's composite sort keys (active#name and
 * status#name), so any mutation touching `active` or `status` has to send
 * `name` with it — AppSync refuses a partial composite key update. That makes
 * every such write a blind rewrite of the name, and a stale copy silently
 * reverts a rename. Reading the current one costs a single small round trip;
 * the generated getService drags the whole record and its connections along.
 */
export const getServiceName = /* GraphQL */ `
  query GetServiceName($id: ID!) {
    getService(id: $id) {
      id
      name
    }
  }
`;
